import Shared from "emun.cart/cart.controller";
import productConfig from "emun.products/product.config";
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import shoppingConfig from "emun.shopping/shopping.config";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import utils from 'webutils/services/util';


export default class CartItemPicker extends Shared {
	constructor($cart, options) {
		super($cart);
		const $ctrl = this;
		basicController($ctrl);
		Object.assign($ctrl, options);
		console.debug("CartItemPickerController", { $ctrl, options });
		$ctrl.bus = new ServiceBus();
	}
	selectProduct(p) {
		const $ctrl = this;

	}

}
